<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">

          <!-- Фильтры -->
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select
                [(ngModel)]="params.storeId"
                (selectChange)="onStoreChanged($event)">
              </hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select
                [(ngModel)]="params.date"
                (selectChange)="navigate()">
              </hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.categories' | transloco }}</small>
              <hx-product-category-select
                [(ngModel)]="params.categoryIds"
                [multiple]="true"
                [brandId]="brandId"
                (ngModelChange)="navigate()">
              </hx-product-category-select>
            </div>
          </div>

          <!-- Кнопки -->
          <div class="m--margin-top-15">
            <button
              type="button"
              *ngIf="params.storeId"
              (click)="generate()"
              class="btn btn-outline-success m--margin-right-10"
              [disabled]="isLoading.generate"
              [ngClass]="{
                'm-loader m-loader--light m-loader--primary m-loader--left': isLoading.generate
              }">
              {{ 'download' | transloco }}
            </button>

            <button
              type="button"
              (click)="resetFilter()"
              class="btn btn-outline-primary">
              {{ 'reset.list' | transloco }}
            </button>
          </div>

          <!-- Таблица -->
          @if (list.length && !isLoading.list) {
            <div class="table-responsive m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
              <table class="m-datatable__table">
                <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">{{ 'inventory-management.table.name' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.unitOfMeasure' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.beginBalance' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.beginTotal' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.income' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.incomeTotal' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.sale' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.saleTotal' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.endDateRemainder' | transloco }}</th>
                  <th class="m-datatable__cell">{{ 'inventory-management.table.endDateRemainderTotal' | transloco }}</th>
                </tr>
                </thead>
                <tbody class="m-datatable__body">
                  @for (im of list; track im) {
                    <tr class="m-datatable__row">
                      <td class="m-datatable__cell">
                        <a
                          routerLink="../inv-mgmt-details" [queryParams]="{
                            productInfoId: im.productInfoId, dateFrom: params.date.from, dateTo: params.date.to, categoryIds: params.categoryIds, storeId: params.storeId,
                          }"
                          class="link-details">
                          {{ im.productInfoTitle | uiLabel }}
                        </a>
                      </td>
                      <td class="m-datatable__cell">{{ im.unitOfMeasure.title | uiLabel }}</td>
                      <td class="m-datatable__cell">{{ im.beginDateRemainder }}</td>
                      <td class="m-datatable__cell">{{ im.beginRemainderTotal }}</td>
                      <td class="m-datatable__cell">{{ im.income }}</td>
                      <td class="m-datatable__cell">{{ im.totalIncome }}</td>
                      <td class="m-datatable__cell">{{ im.sale }}</td>
                      <td class="m-datatable__cell">{{ im.totalSale }}</td>
                      <td class="m-datatable__cell">{{ im.endDateRemainder }}</td>
                      <td class="m-datatable__cell">{{ im.endRemainderTotal }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

        </div>
      </div>
    </div>
  </div>
</div>
